// Core
import React from 'react';
import { Link } from 'react-router-dom';
import css from './style.scss';

const Skill = ({ desc }) => {
  return <li className={ css.li }>{ desc }</li>
}

class Skills extends React.Component {
  jsSkills = [
    'ES5, ES2015',
    'React',
    'Redux',
    'AngularJS (1.x)',
    'Animation (SVG, GSAP)',
    'Unit testing',
    'Canvas',
    'npm'
  ];
  htmlCssSkills = [
    'Semantic Markup',
    'Performant Markup',
    'HTML5 Media',
    'Responsive',
    'CSS3',
    'CSS Animation',
    'Flexbox, CSS Grid, Box Model'
  ];
  backendSkills = [
    'Object Oriented PHP',
    'MySQL',
    'Redis',
    'NodeJS'
  ];
  softwareSkills = [
    'Photoshop',
    'Illustrator',
    'InDesign',
    'Sketch',
    'Apple FCP'
  ];
  componentDidMount() {
    this.props.setParentState({ showVideo: true })
  }
  render() {
    const jsSkillList = this.jsSkills.map(skill => <Skill key={ skill } desc={ skill } />)
    const htmlCssSkillList = this.htmlCssSkills.map(skill => <Skill key={ skill } desc={ skill } />)
    const backendSkillList = this.backendSkills.map(skill => <Skill key={ skill } desc={ skill } />)
    const softwareSkillList = this.softwareSkills.map(skill => <Skill key={ skill } desc={ skill } />)
    return (
      <div>
        <article className={ css.Skills }>
          <h1 className={ css.h1 }>Skills</h1>
          <p className={ css.p }>
            Since starting with frames and tables in the long ago age of 2003, I have picked up many different skills along the way. Some have been lost to the ages (ActionScript 2.0, HTML Emails), and we will not mourn their deaths.
          </p>
          <p className={ css.profile }>
            Read my take on web development and the industry in my <a href="https://thefwa.com/interviews/aaron-sather-and-pete-rugh" target="_blank">developer interview</a> conducted by the FWA.
          </p>
          <h2 className={ css.h2 }>
            JavaScript
          </h2>
          <ul className={ css.ul }>
            { jsSkillList }
          </ul>
          <h2 className={ css.h2 }>
            HTML/CSS
          </h2>
          <ul className={ css.ul }>
            { htmlCssSkillList }
          </ul>
          <h2 className={ css.h2 }>
            Backend
          </h2>
          <ul className={ css.ul }>
            { backendSkillList }
          </ul>
          <h2 className={ css.h2 }>
            Software
          </h2>
          <ul className={ css.ul }>
            { softwareSkillList }
          </ul>
        </article>
        <img src="/images/carl.jpg" className={ css.img } alt="Carl copyright Aaron Sather" />
      </div>
    )
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./app/js/components/Skills/index.js